document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('.site-header__menu-toggle');
  var mobileNav = document.getElementById('MobileNav');
  var overlay = document.querySelector('.site-nav-mobile__overlay');
  var closeBtn = document.querySelector('[data-mobile-nav-close]');

  if (!toggle || !mobileNav) return;

  function openNav() {
    mobileNav.classList.add('is-open');
    if (overlay) overlay.classList.add('is-active');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeNav() {
    mobileNav.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-active');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  toggle.addEventListener('click', function () {
    var isOpen = mobileNav.classList.contains('is-open');
    if (isOpen) {
      closeNav();
    } else {
      openNav();
    }
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', closeNav);
  }

  if (overlay) {
    overlay.addEventListener('click', closeNav);
  }

  // Expandable sub-menus
  var expandBtns = mobileNav.querySelectorAll('.site-nav-mobile__expand');
  expandBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.site-nav-mobile__item--has-children');
      if (!item) return;
      var isExpanded = item.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    });
  });
});
